/* esm.sh - rxjs@7.8.1/dist/esm/internal/util/argsOrArgArray */
var{isArray:n}=Array;function t(r){return r.length===1&&n(r[0])?r[0]:r}export{t as argsOrArgArray};
//# sourceMappingURL=argsOrArgArray.mjs.map